import { useMemo } from "react";
import type { Assignment } from "@cs2/contracts";
import { computeWalkingPathResult, type NavigationData } from "@cs2/physics";

/** Begehbarer Pfad der eigenen Route — Editor (Auswahl) und Quickview (Ich) gleichermaßen. */
export function useOwnWalkPath(
  grid: NavigationData | null,
  route: Assignment["route"],
): ReturnType<typeof computeWalkingPathResult> {
  return useMemo(() => computeWalkingPathResult(grid, route), [grid, route]);
}

/** Begehbare Pfade aller Zuweisungen außer der ausgeschlossenen (eigenen). */
export function useTeamWalkPaths(
  grid: NavigationData | null,
  assignments: readonly Assignment[],
  excludeSlot: string,
): Map<string, ReturnType<typeof computeWalkingPathResult>> {
  return useMemo(() => {
    const paths = new Map<
      string,
      ReturnType<typeof computeWalkingPathResult>
    >();
    for (const assignment of assignments) {
      if (assignment.slot === excludeSlot) continue;
      paths.set(
        assignment.slot,
        computeWalkingPathResult(grid, assignment.route),
      );
    }
    return paths;
  }, [assignments, excludeSlot, grid]);
}
